import { createSlice } from "@reduxjs/toolkit";

//Initial Value of Slice
const initialState = {
    List: [
        {
            Id : "Primary-1",
        }
    ]
}

//Action of Slice
const privacyPolicySlice = createSlice({
    name: "PrivacyPolicy",
    initialState,
    reducers: {}
})

//Export of Slice
export const { } = privacyPolicySlice.actions;
export default privacyPolicySlice.reducer;